import backofficeService from '../../api/backoffice'

export default {

  getCommentByID(params) {
    return backofficeService.Api().get('crm/api/comment', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getActivityByID(params) {
    return backofficeService.Api().get('api/activity', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  create(data) {
    return backofficeService.Api().post('crm/api/comment', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
